export interface Sport {
    id: string
    name: string
    hasSets: boolean
    hasGames: boolean
    hasExtensions: boolean
    hasPenalties: boolean
    hasCaptain: boolean
    hasJerseys: boolean
    numberOfPeriods: number
    periodsName: string
    tableStatistics: string[]
    pointsAwardSystem: string
    status: string
    pointsForWin: number
    pointsForDraw: number
    pointsForLoss: number
    type: string[]
    fieldImageKey: string
    createdAt: string
    updatedAt: string
    translations: Translation[]
    sportEvents: Record<string, unknown>[]
}

export interface DisciplineItem {
    id: string
    name: string
    status: SportStatus
    sex: string[]
    type: string
    measurement: MeasurementType

    createdAt: string
    updatedAt: string
    translations: Translation[]
    sportId: string
    sport: Sport
}

export interface DisciplineRequestBody {
    sportId: string
    disciplineId: string
    name: string
    status: SportStatus
    type: SportType
    sex: Gender[]
    measurement: MeasurementType
    translations: Translation[]
}

export enum SportStatus {
    Active = 'active',
    Inactive = 'inactive',
    Archived = 'archived',
}
type Gender = 'male' | 'female'
enum Translation {
    hr = 'hr',
    en = 'en-GB',
    de = 'de',
    es = 'es',
    fr = 'fr',
    it = 'it',
    pt = 'pt',
}

enum SportType {
    Team = 'team',
    Individual = 'individual',
    TeamIndividual = 'team-individual',
}

export enum MeasurementType {
    Time = 'time',
    Distance = 'distance',
    Points = 'points',
}
